export let currentEmail: null | string = null;
export let setCurrentEmail = (newEmail: null | string) => {
  currentEmail = newEmail;
};
